import { useMemo } from 'react';
import { MAX_CHAR_LIMIT_65 } from '../../../utils/constants';

const PreviewNotifica = (props) => {
  const {
    previewTitle,
    previewText,
    previewImg,
    ttlBackgroundColor,
    triggerTimelineTemplateId
  } = props.values;

  const renderText = () => {
    if (!previewText) {
      return null;
    }

    const plainText = String(previewText || '');
    const truncatedText =
      plainText.length > MAX_CHAR_LIMIT_65
        ? `${plainText.substring(0, MAX_CHAR_LIMIT_65)}...`
        : plainText;

    return (
      <p className="notification-text">
        {truncatedText}
      </p>
    );
  };

  const background = useMemo(() => {
    const gradients = {
      HORIZONTAL_GRADIENT_VIOLET:
        'linear-gradient(90deg, #6E0F73 10%, rgba(227, 20, 127, 0.00) 100%), linear-gradient(90deg, #D9D9D9 0%, rgba(217, 217, 217, 0.00) 76.74%)',
      HORIZONTAL_GRADIENT_BLUE:
        'linear-gradient(90deg, #1D1E67 10%, rgba(17, 108, 160, 0.00) 100%), linear-gradient(90deg, #D9D9D9 0%, rgba(217, 217, 217, 0.00) 76.74%)',
      HORIZONTAL_GRADIENT_BLACK:
        'linear-gradient(90deg, #000 10%, rgba(37, 38, 39, 0.00) 100%), linear-gradient(90deg, #D9D9D9 0%, rgba(217, 217, 217, 0.00) 76.74%)',
      HORIZONTAL_GRADIENT_SILVER:
        'linear-gradient(90deg, #D7D7D7 10%, rgba(215, 215, 215, 0.00) 100%)'
    };

    return gradients[ttlBackgroundColor] || gradients.HORIZONTAL_GRADIENT_VIOLET;
  }, [ttlBackgroundColor]);

  return (
    <div className={`dark-background ${triggerTimelineTemplateId && triggerTimelineTemplateId !== 'DEFAULT' ? 'alert' : ''} `}>
      { triggerTimelineTemplateId && triggerTimelineTemplateId !== 'DEFAULT'
          ?
            <div className="alertBox">
              <i className="nexi-icon-warning"></i>
              <p className="warning">Template non disponibile in modalità Notifica.</p>
              <p className="warning">Selezionare TAB DESKTOP per visionare l'anteprima.</p>
            </div>
          :
      <div
        style={{background: `${background}, url(${previewImg}) lightgray 50% / cover no-repeat`}}
        className={`notification-container ${ttlBackgroundColor}`}
      >
        <div className="notification-text">
          {previewTitle && (
            <h3 className="notification-title">{previewTitle}</h3>
          )}

          {renderText()}
          {
            <a className="anchor banner-link">
              {'Scopri di più'}
              <i className="portal-icon-arrow-right" />
            </a>
          }
        </div>
      </div>
}
    </div>
  );
};

export default PreviewNotifica;
